module.exports = __webpack_public_path__ + "img/glassquality_3.34510f6a.png";